// extracted by mini-css-extract-plugin
export default {"addToCartControl":"cZ-z","giftCard":"dZ-z","btnContainer":"eZ-z","cartButton":"fZ-z","disabled":"gZ-z"};